import { Component } from '@angular/core';

@Component({
  selector: 'app-training-impact-settings',
  templateUrl: './training-impact-settings.component.html',
  styleUrl: './training-impact-settings.component.scss'
})
export class TrainingImpactSettingsComponent {

}
